import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'
import '@splidejs/splide/css'
import { Splide } from '@splidejs/splide'

const app = Application.start()

app.register('refosumu--home-index--latest-content--component', class extends Controller {
  static targets = ['sliderExamplePc', 'sliderExampleSp', 'sliderReviewPc', 'sliderReviewSp']

  connect() {
    this.initializeSliders()
  }

  initializeSliders() {
    // 事例カルーセル（PC）
    if (this.hasSliderExamplePcTarget) {
      const examplePcSlides = this.sliderExamplePcTarget.querySelectorAll('.splide__slide')
      const examplePcSlideCount = examplePcSlides.length

      const examplePcConfig = {
        type: 'loop',
        padding: '5rem',
        gap: '24px',
        pagination: false,
        arrows: examplePcSlideCount > 1,
        autoWidth: true,
        focus: 'center',
        updateOnMove: true,
      }

      const examplePcSplide = new Splide(this.sliderExamplePcTarget, examplePcConfig)
      examplePcSplide.mount()
    }

    // 事例カルーセル（SP）
    if (this.hasSliderExampleSpTarget) {
      const exampleSpSlides = this.sliderExampleSpTarget.querySelectorAll('.splide__slide')
      const exampleSpSlideCount = exampleSpSlides.length

      const exampleSpConfig = {
        type: 'loop',
        pagination: false,
        arrows: exampleSpSlideCount > 1,
        height: 'auto',
        fixedHeight: true,
      }

      const exampleSpSplide = new Splide(this.sliderExampleSpTarget, exampleSpConfig)
      exampleSpSplide.mount()
    }

    // 口コミカルーセル（PC）
    if (this.hasSliderReviewPcTarget) {
      const reviewPcSlides = this.sliderReviewPcTarget.querySelectorAll('.splide__slide')
      const reviewPcSlideCount = reviewPcSlides.length

      const reviewPcConfig = {
        type: 'loop',
        padding: '5rem',
        gap: '24px',
        pagination: false,
        arrows: reviewPcSlideCount > 1,
        perPage: 2,
        perMove: 1,
      }

      const reviewPcSplide = new Splide(this.sliderReviewPcTarget, reviewPcConfig)
      reviewPcSplide.mount()
    }

    // 口コミカルーセル（SP）
    if (this.hasSliderReviewSpTarget) {
      const reviewSpSlides = this.sliderReviewSpTarget.querySelectorAll('.splide__slide')
      const reviewSpSlideCount = reviewSpSlides.length

      const reviewSpConfig = {
        type: 'loop',
        padding: '4rem',
        gap: '24px',
        pagination: false,
        arrows: reviewSpSlideCount > 1,
        height: 'auto',
        fixedHeight: true,
      }

      const reviewSpSplide = new Splide(this.sliderReviewSpTarget, reviewSpConfig)
      reviewSpSplide.mount()
    }
  }
})
